import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export interface StudyMaterialPreviewResponse {
  file_name: string;
  pdf_content: string;
}

export const StudyMaterialPreviewSlice = createSlice({
  name: "StudyMaterialPreviewSlice",
  initialState: {} as IReduxState<StudyMaterialPreviewResponse>,
  reducers: {
    StudyMaterialPreview: (state, _) => {
      state.isLoading = true;
    },
    successStudyMaterialPreview: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureStudyMaterialPreview: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearStudyMaterialPreview: (state) => {
      state.data = {};
    },
  },
});

export const {
  StudyMaterialPreview,
  successStudyMaterialPreview,
  failureStudyMaterialPreview,
  clearStudyMaterialPreview,
} = StudyMaterialPreviewSlice.actions;

export default StudyMaterialPreviewSlice.reducer;
